import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { arrayBufferToBase64 } from 'utils/Helper';
import Logo from 'assets/img/Logo.png';

const SecureImage = (props) => {
    const [image, setImage] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const response = await axios.get(props.source, {
                    responseType: 'arraybuffer',
                });

                const image = arrayBufferToBase64(response.data);

                setImage(
                    `data:${response.headers['content-type']};base64,${image}`
                );
                setLoading(false);
            } catch (err) {
                setError(err);
            }
        })();
    }, []);

    return !loading ? <img src={!error ? image : Logo} {...props} /> : '';
};

export default SecureImage;
